module.exports = __webpack_public_path__ + "img/icon_dd.51643718.png";